<template>
  <common-page-layout class="googlelayout">
      <iframe width="600" height="450" frameborder="0" style="border:0" src="https://www.google.com/maps/?q=-15.623037,18.388672" allowfullscreen></iframe>        
  </common-page-layout>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  
  export default {
    name: "GoogleMap",
    data() {
      return {
        msg: ""
      };
    },    
    computed: mapGetters(["business"]),
    beforeDestroy() {},
    destroy() {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  /* Shared */
  
  .googlelayout {
    padding: 100px 0;
    text-align: center;
    /* margin: auto;
          width: 50%; */
    /* border: 3px solid green; */
    /* padding: 10px; */
  } 
  
</style>



// WEBPACK FOOTER //
// src/components/GoogleMap.vue